import { render, staticRenderFns } from "./forgot_password.vue?vue&type=template&id=2d9cff79"
import script from "./forgot_password.vue?vue&type=script&lang=js"
export * from "./forgot_password.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports